"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferTemplatesMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
const OfferTemplateMapper_1 = require("./OfferTemplateMapper");
class OfferTemplatesMapper {
    constructor(lang) {
        this.lang = lang;
    }
    formatOfferTemplates(offerTemplates) {
        return lodash_1.default.flatten(offerTemplates.map((edge) => new OfferTemplateMapper_1.OfferTemplateMapper(this.lang).toDomain(lodash_1.default.get(edge, "node"))));
    }
    toDomain(result) {
        const isOffersLoading = lodash_1.default.get(result, "loading");
        const offerTemplates = this.formatOfferTemplates(lodash_1.default.get(result, "data.list.edges"));
        return {
            isOffersLoading,
            offerTemplates,
        };
    }
}
exports.OfferTemplatesMapper = OfferTemplatesMapper;
